<template>
  <div class="coupon-useDetails" ref="container">
    <div class="nav acea-row">
      <div
        class="item"
        :class="types === 2 ? 'on' : ''"
        @click="changeTypes(2, 'useTime')"
      >
        已使用
      </div>
      <div
        class="item"
        :class="types === 3 ? 'on' : ''"
        @click="changeTypes(3, 'endTime')"
      >
        已过期
      </div>
    </div>
    <div class="coupon-list" v-if="list.length > 0">
      <div
        class="item acea-row row-center-wrapper norestriction"
        v-cloak
        v-for="(item, index) in list"
        :key="index"
      >
        <div class="money moneyGray">
          <div>
            <span class="num"
              >{{ item.couponPrice
              }}<span class="co-integral" v-if="item.couponType === 1"
                >积分</span
              ><span class="co-integral" v-else>折</span>
            </span>
          </div>
          <div class="pic-num" v-if="item.condition > 0">
            满{{ item.condition
            }}<span v-if="item.conditionType === 1">积分</span
            ><span v-else>件</span>可用
          </div>
          <div class="pic-num" v-else>
            无门槛
          </div>
        </div>
        <div class="text">
          <div class="condition line1">
            {{ item.couponTitle }}
          </div>
          <div class="data acea-row row-between-wrapper">
            <div>
              <div>{{ item.startTime }} - {{ item.endTime }}</div>
            </div>
          </div>
          <div class="data2">
            <div v-if="item.sharePreferential" class="acea-row">
              <span v-if="item.sharePreferential.indexOf('优惠券') >= 0"
                >可叠加使用<span v-if="item.sharePreferential !== '优惠券'"
                  >，</span
                ></span
              >
              <span
                v-if="
                  item.sharePreferential.indexOf('限时折扣') >= 0 &&
                    item.sharePreferential.indexOf('满减/送') >= 0
                "
                >可与限时折扣、满减活动同享</span
              >
              <span v-else-if="item.sharePreferential.indexOf('限时折扣') >= 0"
                >可与限时折扣活动同享</span
              >
              <span v-else-if="item.sharePreferential.indexOf('满减/送') >= 0"
                >可与满减活动同享</span
              >
            </div>
          </div>
          <div class="coupon-cion">
            <div class="used" v-if="types === 2"></div>
            <div class="outdate" v-else-if="types === 3"></div>
          </div>
        </div>
      </div>
    </div>
    <!--暂无优惠券-->
    <div class="noCommodity" v-if="list.length === 0">
      <div class="noPictrue">
        <img
          src="@assets/images/noUseCoupon.png"
          class="image"
          v-if="types === 2"
        />
        <img src="@assets/images/noExpireCoupon.png" class="image" v-else />
      </div>
    </div>
  </div>
</template>
<script>
import { getCouponsUser } from "@api/user";
import { dataFormatT } from "@utils";
export default {
  name: "CouponUsageRecord",
  components: {},
  props: {},
  data: function() {
    return {
      types: 2,
      where: {
        status: 2,
        sort: "useTime"
      },
      list: []
    };
  },
  watch: {
    types: function() {
      this.getCouponList();
    }
  },
  mounted: function() {
    let that = this;
    that.getCouponList();
  },
  methods: {
    changeTypes: function(val, sort) {
      if (val != this.types) {
        this.types = val;
        this.list = [];
        this.where.status = val;
        this.where.sort = sort;
      }
    },
    getCouponList: function() {
      let that = this;
      getCouponsUser(that.where).then(
        res => {
          that.list = res.data;
        },
        error => {
          that.$dialog.message(error.msg);
        }
      );
    }
  }
};
</script>
